module.exports = __webpack_public_path__ + "static/media/invoice_chart.04e5e4c5.svg";